<template>
  <section class="image-module-component">
    <div class="inner-container">
      <h1 class="heading-1">Heading 1</h1>
      <h2 class="heading-2">Heading 2</h2>
      <h3 class="heading-3">Heading 3</h3>
      <h4 class="heading-4">Heading 4</h4>
      <p class="large">Body large lorem ipsum dolore sit amet.</p>
      <p class="medium">Body medium lorem ipsum dolore sit amet.</p>
      <p class="small">Body small lorem ipsum dolore sit amet.</p>
      <p class="caption">Caption lorem ipsum dolore sit amet.</p>
      <p>Regular content Paragraph.</p>
      <img
        rel="preload"
        as="image"
        :src="props.data.module_image_url.url"
        :alt="props.data.module_image_url.alt" />
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "ImageComponent",
  "CLASSNAME": "image-module-component",
  "URL": "http://lifemine.local/templates/"
 }
#ENDMETA */

const props = defineProps(['data'])
</script>

<style lang="scss">
.image-module-component {
  img {
    @apply my-24;
  }
}
</style>
